import {
  all,
  takeLatest,
  fork,
  call,
  put,
  select,
} from "@redux-saga/core/effects";
import { updateApiCallStatus } from "app/actions";
import { successSavingName } from "app/common/NumberCard/action";
import { setPairedLine } from "app/common/NumberCard/action/pairedLinesAction";
import { setUnAssignedLine } from "app/LineDetails/actions";
// import { setUnAssignedLine } from 'app/LineDetails/actions'
import { RootState } from "app/reducers";
import { Category } from "app/utils/categories";
import { DecryptJSON } from "app/utils/crypto";
import { extractmsisdn } from "app/utils/helper";
import SDK from "../../sdk";
import {
  setDeviceList,
  setLineDeleveDetails,
  setPrimaryDevice,
  successDeactivateLine,
  updateError,
} from "../actions";
import { LineDelveTypes } from "../actions/index.model";
import XMLParser from "react-xml-parser";
const state = (state: RootState) => state;
function* getLineDelveDetails() {
  yield takeLatest(LineDelveTypes.GET_LINE_DELVE_DETAILS, GetLineDelveDetails);
}

function* removeGranteeEmail() {
  yield takeLatest(LineDelveTypes.REMOVE_GRANTEE_EMAIL, RemoveGranteeEmail);
}
function* getDeviceList() {
  yield takeLatest(LineDelveTypes.GET_DEVICE_LIST, GetDeviceList);
}
function* deactivateLine() {
  yield takeLatest(LineDelveTypes.DEACTIVATE_LINE, DeactivateLine);
}
function* getPrimaryDevice() {
  yield takeLatest(LineDelveTypes.GET_PRIMARY_DEVICE, GetPrimaryDevice);
}

function* getPairedLine() {
  yield takeLatest(LineDelveTypes.GET_PAIRED_LINE, GetPairLine);
}

export function* GetPairLine(action: any): any {
  try {
    const response = yield call(SDK.getLinePair, action.data.msisdn);
    let pairedLines: any[] = [];
    if (response) {
      var xml = new XMLParser().parseFromString(response);

      const pairedDevice = extractmsisdn(xml.getElementsByTagName("sipUri"));
      if (Array.isArray(pairedDevice)) {
        pairedDevice.forEach((device: any) => {
          pairedLines.push({ msisdn: device });
        });
      } else {
        pairedLines.push({ msisdn: pairedDevice });
      }
      const lineRes = yield all(
        pairedLines.map((line: any) =>
          call(SDK.getLineDelveDetails, line.msisdn)
        )
      );
      // lineRes.forEach((res: any) => {
      //   if (res) {
      //     res?.implicitPermissions.forEach((data: any) =>
      //       data.lines.forEach((line: any) => {
      //         let name = "Unnamed";
      //         if (line.givenName) {
      //           name = line.givenName;
      //         }
      //         pairedLines.forEach((pLine: any) => {
      //           if (pLine.msisdn === line.msisdn) {
      //             pLine.givenName = name;
      //           }
      //         });
      //       })
      //     );
      //   }
      // });
      pairedLines=handlePairedLinesResponse(lineRes,pairedLines)
    }
    yield put(setPairedLine(pairedLines));
  } catch (e) {
    console.log(e, "error");
  }
}
 function  handlePairedLinesResponse(lineRes:any,pairedLines:any){
  lineRes.forEach((res: any) => {
    if (res) {
      res?.implicitPermissions.forEach((data: any) =>
        data.lines.forEach((line: any) => {
          let name = "Unnamed";
          if (line.givenName) {
            name = line.givenName;
          }
          pairedLines.forEach((pLine: any) => {
            if (pLine.msisdn === line.msisdn) {
              pLine.givenName = name;
            }
          });
        })
      );
    }
  });
  return pairedLines;
 }
export function* DeactivateLine(action: any): any {
  try {
    const stateData: RootState = yield select(state);

    const apiStatusData = stateData.app.apiCallsStatus.find(
      (item) => item.module === LineDelveTypes.DEACTIVATE_LINE
    );
    let noOfAttempts: number = 0;
    if (apiStatusData && apiStatusData?.noOfAttempts) {
      noOfAttempts = apiStatusData.noOfAttempts;
    }
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: LineDelveTypes.DEACTIVATE_LINE,
        noOfAttempts: noOfAttempts + 1,
      })
    );
    let query = `?msisdn=${action.data.id}&deviceId=${action.data.deviceId}`;
    let res = yield call(SDK.deactivateLine, query);

    if (res) {
      yield put({
        type: LineDelveTypes.GET_DEVICE_LIST,
        data: { msisdn: action.data.id },
      });
      yield put(
        updateApiCallStatus({
          status: "success",
          module: LineDelveTypes.DEACTIVATE_LINE,
        })
      );
      yield put(successDeactivateLine(""));
    }
  } catch (e) {
    yield put(
      updateApiCallStatus({
        status: "error",
        module: LineDelveTypes.DEACTIVATE_LINE,
      })
    );
  }
}
export function* GetPrimaryDevice(action: any): any {
  try {
    const query = `?imsi=${action.data.imsi}`;
    const res = yield call(SDK.getPrimaryDevice, query);
    if (res) {
      yield put(setPrimaryDevice(res));
    }
  } catch (e) {
    yield put(setPrimaryDevice([]));
  }
}
export function* GetDeviceList(action: any): any {
  try {
    const query = `?msisdn=${action.data.msisdn}`;
    const res = yield call(SDK.getDeviceList, query);
    if (res && !res.errorCode) {
      yield put(setDeviceList(res.vimsis));
    } else {
      yield put(setDeviceList([]));
    }
  } catch (e) {
    console.log("errr-", e);
  }
}
export function* RemoveGranteeEmail(action: any): any {
  try {
    const data: RootState = yield select(state);
    
    let userInfo = data.allLines.userDetails;
    const apiStatusData = data.app.apiCallsStatus.find(
      (item) => item.module === LineDelveTypes.REMOVE_LINEDELVE_STATUS
    );

    let noOfAttempts: number = getNoOfAttempts(apiStatusData);//0;
    if (apiStatusData && apiStatusData?.noOfAttempts) {
      noOfAttempts = apiStatusData.noOfAttempts;
    }

   const deviceDetails=getDeviceDetails(action,data)

    let deviceName=deviceDetails.deviceName;
    let grantee=deviceDetails.grantee;
    let msisdn=deviceDetails.msisdn;
    let grantorUid=deviceDetails.grantorUid;
    let lineType=deviceDetails.lineType;

    yield put(
      updateApiCallStatus({
        status: "pending",
        module: LineDelveTypes.REMOVE_LINEDELVE_STATUS,
        noOfAttempts: noOfAttempts + 1,
      })
    );
    const snackMessage = `${grantee} has beeen removed from the line ${deviceName}`;
    const query = `?grantorUid=${grantorUid}&grantee=${encodeURIComponent(
      grantee
    )}&msisdn=${msisdn}&lineType=${lineType}`;
    const res = yield call(SDK.removeGranteeEmail, query);
    if (res === undefined || (res && res.status && res.status !== 200)) {
      throw new Error("error");
    } else {

      if (action.data?.type === Category.lineSharedID) {
        //yield put(resetLineDetails());
        //yield put(getLineDetails());
      } else {
        const lines = yield call(SDK.getLineDelveDetails, msisdn);

        //yield call(SDK.sendEmail, email_payload, lines);
        if (grantee === userInfo.email) {
          yield put(setUnAssignedLine("1" + msisdn));
        }
        yield put(
          setLineDeleveDetails({ res: lines, grantorEmail: userInfo.email })
        );
      }
      // yield put(removeGranteeSuccess({ grantee }));
      yield put(successSavingName({ message: snackMessage }));
      yield put(
        updateApiCallStatus({
          status: "success",
          module: LineDelveTypes.REMOVE_LINEDELVE_STATUS,
          noOfAttempts: 0,
        })
      );
    }
  } catch (err) {
    console.log(err, "error-section");
    //yield put(setLoading(false));
    // yield put(removeGranteeFail());
    // yield put(failureSavingName({ isError: true }));
    yield put(
      updateApiCallStatus({
        status: "error",
        module: LineDelveTypes.REMOVE_LINEDELVE_STATUS,
      })
    );
  }
}

function getNoOfAttempts(apiStatusData:any){
  let noOfAttempts: number = 0;
  if (apiStatusData && apiStatusData?.noOfAttempts) {
    noOfAttempts = apiStatusData.noOfAttempts;
  }
  return noOfAttempts;
}

function getDeviceDetails(action:any,data:any){
  let grantorUid;
  let lineType;
  let deviceName;
  let grantee;
  let msisdn;
  if (
    !action.data?.grantee &&
    (action.data?.type === Category.lineSharedID ||
      action.data?.type === Category.assignedID)
  ) {
    let selectedLine=getSelectedLine(data,action);
    
    grantorUid = selectedLine.grantor
      ? selectedLine.grantor.split(":")[1]
      : data.allLines.userDetails.orig_tmobileid;
    lineType = selectedLine.LineType;
    deviceName = selectedLine.givenName;
    grantee = selectedLine.granteeEmail
      ? selectedLine.granteeEmail
      : data.allLines.userDetails.email;
    msisdn = action.data.id.substring(1);
  } else {
    var userEmailDetails = data.lineDelve.lineDelveDetails.userEmails.filter(
      (item:any) => {
        return item.granteeEmail === action.data.grantee;
      }
    );
    if (userEmailDetails.length > 0) {
      var grantorUserId = userEmailDetails[0].grantor.split("userid:");
      grantorUid = grantorUserId[1]; 
    }

    lineType = data.allLines.selectedLineDetails.lineType.toLowerCase();
    deviceName = data.allLines.selectedLineDetails.deviceName;
    grantee = action.data.grantee;
    msisdn = action.data.id.substring(1);
  }
  return{
    grantorUid,lineType,deviceName,grantee,msisdn
  }
}

function getSelectedLine(data:any,action:any){
  let selectedLine: any;
  data.allLines.lineDetails.forEach((item:any) => {
    if (
      item.id === Category.lineSharedID ||
      item.id === Category.assignedID
    ) {
      item.lines.forEach((line:any) => {
        if (line.MSISDN === action.data.id) {
          selectedLine = line;
        }
      });
    }
  });
  return selectedLine;
}

export function* GetLineDelveDetails(action: any): any {
  try {
    const userDetails = DecryptJSON(sessionStorage.getItem("userDetails"));
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: LineDelveTypes.LINE_DELVE_STATUS,
      })
    );
    const response = yield call(SDK.getLineDelveDetails, action.data.id);
    yield put(
      setLineDeleveDetails({ res: response, grantorEmail: userDetails?.email })
    );
    yield put(updateError(""));
    yield put(
      updateApiCallStatus({
        status: "final",
        module: LineDelveTypes.LINE_DELVE_STATUS,
      })
    );
  } catch (error) {
    if (typeof error === "string") {
      yield put(updateError(error));
    }
    yield put(setLineDeleveDetails([]));
    yield put(
      updateApiCallStatus({
        status: "error",
        module: LineDelveTypes.LINE_DELVE_STATUS,
      })
    );
  }
}

export default function* LineDelveSaga() {
  yield all([
    fork(getLineDelveDetails),
    fork(getPairedLine),
    fork(removeGranteeEmail),
    fork(getDeviceList),
    fork(getPrimaryDevice),
    fork(deactivateLine),
  ]);
}
